import { type FC } from "react";

import { Button, Group, Modal, Text } from "@mantine/core";

import {
    DeleteConfirmButton,
    DeleteConfirmCancel,
    DeleteConfirmMessage,
    DeleteConfirmSingleMessage,
    DeleteConfirmTitle,
} from "./messages.generated";

interface DeleteConfirmModalProps {
    opened: boolean;
    onConfirm: () => void;
    onCancel: () => void;
    count: number;
    isDeleting: boolean;
}

export const DeleteConfirmModal: FC<DeleteConfirmModalProps> = ({ opened, onConfirm, onCancel, count, isDeleting }) => {
    return (
        <Modal opened={opened} onClose={onCancel} title={<DeleteConfirmTitle />} centered>
            <Text size="sm" mb="lg">
                {count === 1 ? <DeleteConfirmSingleMessage /> : <DeleteConfirmMessage count={count} />}
            </Text>
            <Group justify="flex-end" gap="sm">
                <Button variant="default" onClick={onCancel}>
                    <DeleteConfirmCancel />
                </Button>
                <Button color="red" onClick={onConfirm} loading={isDeleting}>
                    <DeleteConfirmButton />
                </Button>
            </Group>
        </Modal>
    );
};
